import React, { useState, useEffect } from 'react'
import PromotionOneWalletModal from '../../../pages/PromotionOneWalletModal';
import { Button, Col, Input, Select, Modal, Spin } from 'antd';
import { applyCampaign, cancelCampaign, checkSignUpBonus, SignUpBonusClickToCancelConfig } from '../../../data/wallet';
import { useDispatch, useSelector } from 'react-redux';
import { piwikBonus } from '../../../actions/piwikUtil';
import { showErrorToast, showSuccessToast } from '../../../actions/helper';
import { handleCancelSignUpBonusError } from '../../../actions/util';
import { promotionActions } from '../../../store/promotionSlice';

export default function AssignedClaimCancelForm ({ handleClose, item, visible, data, ...props }) {
    const [memberInfo, setMemberInfo] = useState(
        JSON.parse(localStorage.getItem("memberInfo")) || {}
    );
    const [modalProps, setModalProps] = useState({});
    const [apiError, setApiError] = useState({});
    const [showErorModal, setShowErrorModal] = useState(false);;
    const [isFetching, setIsFetching] = useState(false);
    const [checked, setChecked] = useState(false);
    const userCenter = useSelector((state) => state.userCenter);
    const dispatch = useDispatch();
    console.log("userCenteruserCenter", userCenter);
    useEffect(() => {
        console.log("Member Info:", memberInfo);
        console.log("AssignedClaimCancelForm:", item);
    }, [memberInfo?.userName]);

    const claerAllstated = () => {
        setMemberInfo({});
        setModalProps({});
        setApiError({});
        setShowErrorModal(false);
        setChecked(false);
    }

    useEffect(() => {
        return () => {
            claerAllstated()
        }
    }, [])

    const checkIsDisabled = () => isFetching || !checked;

    const handleCheckboxChange = () => {
        setChecked((prev) => !prev);
    };

    const cancelBonusInAction = async () => {
        return cancelCampaign(item?.participantId, item?.productGroups?.[0]?.productGroup)
    }

    const handleSubmitForm = async () => {
        console.log("handleSubmitFormEnter", item, data);
        setIsFetching(true);
    
        try {
            const resp = await checkSignUpBonus(item?.productGroups?.[0]?.productGroup);
            console.log("checkSignUpBonus", resp);
    
            if (checkSignUpBonus.isSignupBonus(resp)) {
                console.log("isSignupBonusCancelFlow");
                const callBackOnClickConfirm = async () => {
                    console.log("callBackOnClickConfirm");
                    try {
                        const resp = await cancelBonusInAction();
                        console.log("cancelCampaign", resp);
    
                        if (resp?.isSuccess) {
                            handleClose();
                            showSuccessToast();
                            dispatch(promotionActions.setPromotionSecondLayerTab("2"));
                        } else {
                            let err = handleCancelSignUpBonusError(resp);
                            console.log("err2094", err);
    
                            if (err?.showModal) {
                                setShowErrorModal(true);
                                setApiError(err.config);
                                return;
                            }
                            showErrorToast();
                        }
                    } catch (error) {
                        console.error("Error in cancelCampaign:", error);
                        item?.showToastAfterFailure?.();
                    }
                };
    
                setModalProps({
                    handleClose: () => {setShowErrorModal(false); setApiError({})},
                    callback: callBackOnClickConfirm,
                });
                setApiError(SignUpBonusClickToCancelConfig());
                setShowErrorModal(true);
            } else {
                try {
                    const resp = await cancelBonusInAction();
                    console.log("cancelBonusInAction", resp);
    
                    if (resp?.isSuccess) {
                        handleClose();
                        showSuccessToast();
                    } else {
                        let err = handleCancelSignUpBonusError(resp);
                        console.log("err2123", err);
    
                        if (err?.showModal) {
                            setShowErrorModal(true);
                            setApiError(err.config);
                            return;
                        }
                        showErrorToast();
                    }
                } catch (error) {
                    console.error("Error in cancelBonusInAction:", error);
                    showErrorToast();
                }
            }
        } catch (error) {
            console.error("Error in checkSignUpBonus:", error);
            showErrorToast();
        } finally {
            setIsFetching(false);
        }
    };
    

    const { pullbackAmount = 0, bonusGiven = 0 } =
        data?.data || {};
    const givenAmount = item?.givenAmount || 0;

    return (
        <Modal visible={visible} footer={null} closable={false} width={426}>
        <div className="PromotionManualPromotionApplicationForm">
        <Spin spinning={isFetching}>
        <div className="PromotionManualPromotionApplicationForm">
            <span
                onClick={() => {
                    handleClose();
                    claerAllstated();
                }}
                style={{
                    position: "absolute",
                    top: "15px",
                    right: "-3px",
                    zIndex: "10",
                    cursor: "pointer",
                }}
            >
                <img
                    src="/vn/img/1wallet/00/ModalCloseIcon.svg"
                    alt="Close Icon"
                />
            </span>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        marginTop: "55px",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#222222",
                    }}
                >
                    Quan trọng
                </div>
            </Col>
            <Col
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "15px",
                }}
            >
                <img
                    src="/vn/img/1wallet/00/OWCancelFlowIcon.svg"
                    alt="OWCancelFlowIcon"
                />
            </Col>
            <Col
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        padding: "0 10px",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#666666",
                        width: "100%",
                    }}
                >
                    {pullbackAmount ? (
                        `Bạn hiện có một khuyến mãi đang diễn ra. Khuyến mãi hiện tại sẽ bị hủy và ${pullbackAmount} đ sẽ bị thu hồi.`
                    ) : (
                        <div>
                            <div>
                                Bạn hiện có một khuyến mãi đang diễn ra.
                                Khuyến mãi
                            </div>
                            <div>hiện tại sẽ bị hủy.</div>
                        </div>
                    )}
                </div>
            </Col>
            <Col
                style={{
                    marginBottom: "15px",
                    backgroundColor: "#EFEFF4",
                    fontSize: "12px",
                    fontWeight: "400",
                    padding: "10px 15px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            color: "#999999",
                        }}
                    >
                        Thưởng Khuyến mãi đang diễn ra
                    </div>
                    <div
                        style={{
                            color: "#222222",
                        }}
                    >
                        {bonusGiven} đ
                    </div>
                </div>
                <hr
                    style={{
                        width: "90%", // Slightly narrower to leave some padding
                        height: "1px", // Thin line
                        backgroundColor: "#E0E0E0", // Light gray color
                        border: "none", // Remove default border
                        margin: "10px auto", // Center the divider with spacing
                        borderRadius: "5px", // Smooth edges
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            color: "#999999",
                        }}
                    >
                        Thưởng Khuyến mãi mới
                    </div>
                    <div
                        style={{
                            color: "#222222",
                        }}
                    >
                        {givenAmount} đ
                    </div>
                </div>
            </Col>
            <Col
                style={{
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "400",
                }}
            >
                <div>
                    Doanh thu tích lũy trong Thời gian Khuyến mãi sẽ
                    không
                </div>
                <div>còn hiệu lực</div>
            </Col>

            <Col
                style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#666666",
                }}
            >
                <div className="checkbox-container-OW">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={handleCheckboxChange}
                    />
                    <label
                        onClick={handleCheckboxChange}
                        style={{ cursor: "pointer" }}
                    >
                        Tôi đã đọc nội dung trên và{" "}
                        <strong style={{ color: "#222222" }}>
                            đồng ý hủy bỏ ưu đãi.
                        </strong>
                    </label>
                </div>
            </Col>
            <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                <Button
                    style={{
                        color: checked ? "#FFFFFF" : "#999999",
                        backgroundColor: checked ? "#00A6FF" : "#E3E3E3",
                        fontWeight: "400"
                    }}
                    className="PromotionManualPromotionApplicationForm-submit"
                    disabled={checkIsDisabled()}
                    onClick={() => {
                        // handleClose();
                        console.log("Button clicked! Calling handleSubmitForm...",data);
                        piwikBonus.run10(data?.message)
                        handleSubmitForm();
                    }}
                >
                    Xác nhận
                </Button>
            </Col>
            <Col className="PromotionManualPromotionApplicationForm-submit-container application-form">
                <Button
                    style={{
                        marginTop: "10px",
                        color: "#00A6FF",
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #00A6FF",
                        fontWeight: "400"
                    }}
                    className="PromotionManualPromotionApplicationForm-submit"
                    onClick={() => {
                        handleClose();
                        // handleSubmitForm();
                    }}
                >
                    Quay lại
                </Button>
            </Col>
            <PromotionOneWalletModal
                isVisible={showErorModal}
                config={apiError}
                onClose={() => {
                    setShowErrorModal(false);
                    setApiError({});
                    setModalProps({});
                }}
                props={modalProps}
            />
        </div>
        </Spin>
        </div>
        </Modal>
    );
}